// extracted by mini-css-extract-plugin
module.exports = {"demo_case_study":"DemoCaseStudy_demo_case_study__1eMTG","demo_case_study__case":"DemoCaseStudy_demo_case_study__case__1mj_e"};